import {push} from 'react-router-redux';
import * as AuthActions from '../actions/auth';
import {fetchProfile, resetPassword} from '../utils/api';

export const authEpic = (action$) => {
  return action$.ofType(AuthActions.LOGIN)
    .map(action => AuthActions.loginSuccess(btoa(`${action.payload.username}:${action.payload.password}`)));
};

export const fetchProfileEpic = (action$) => {
  return action$.ofType(AuthActions.LOGIN_SUCCESS)
    .mergeMap(action => {
      return fetchProfile(action.payload)
        .then(res => AuthActions.fetchProfileSuccess(res.data))
        .catch(err => AuthActions.fetchProfileFailed('Invalid login'));
    });
};

export const fetchProfileSuccessEpic = (action$) => {
  return action$.ofType(AuthActions.FETCH_PROFILE_SUCCESS)
    .map(action => push('/'));
};

export const logoutEpic = (action$) => {
  return action$.ofType(AuthActions.LOGOUT)
    .map(action => push('/login'));
};

export const resetPasswordEpic = (action$) => {
  return action$.ofType(AuthActions.RESET_PASSWORD)
    .mergeMap(action => {
      return resetPassword(action.payload)
        .then(res => push('/'))
        .catch(err => AuthActions.resetPasswordFailed('There was a problem'));
    });
};


// WEBPACK FOOTER //
// ./src/epics/auth.js